document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mt-shot-video').forEach(initSection);
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('.mt-shot-video')
      ? event.target
      : event.target.querySelector('.mt-shot-video');
    if (section) initSection(section);
  });
});

function initSection(section) {
  var video = section.querySelector('.mt-shot-video-player');
  var replayBtn = section.querySelector('.mt-shot-video-replay');
  var card = section.querySelector('.mt-shot-video-card');

  if (!video) return;

  var shouldLoop = video.loop || video.hasAttribute('loop');
  var shouldAutoplay = video.autoplay || video.hasAttribute('autoplay');

  var hideReplay = function () {
    if (replayBtn) replayBtn.classList.remove('is-visible');
  };

  var showReplay = function () {
    if (replayBtn) replayBtn.classList.add('is-visible');
  };

  var markPlaying = function () {
    if (card) card.classList.add('is-playing');
    hideReplay();
  };

  var tryAutoplay = function () {
    if (!shouldAutoplay) return;

    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        if (!shouldLoop && replayBtn) showReplay();
      });
    }
  };

  video.muted = true;
  video.playsInline = true;
  if (shouldLoop) video.loop = true;

  hideReplay();
  tryAutoplay();

  video.addEventListener('play', markPlaying);
  video.addEventListener('loadedmetadata', tryAutoplay);

  if (!shouldLoop) {
    video.addEventListener('ended', showReplay);
  }

  if (replayBtn) {
    replayBtn.addEventListener('click', function () {
      video.currentTime = 0;
      hideReplay();
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }
}
